import SiteConfig from "@/common/SiteConfig";
// import { SessionProvider } from "next-auth/react"
import '../styles/globals.css'
import styles from '../styles/Home.module.css'
import { useEffect } from "react";
import dynamic from 'next/dynamic';
const Prompt = dynamic(() => import("@/frontend/root/Prompt.tsx").then(x => x.default), { ssr: false })
const QELoader = dynamic(() => import("@/frontend/root/QELoader.tsx").then(x => x.default), { ssr: false })

// import Prompt from '@/frontend/root/Prompt.tsx'
import Script from 'next/script';

// const XMPP = dynamic(() => import('@/frontend/components/xmpp/xmpp.min.js').then(x => x.default), { ssr: false })

// import { client as xmppclient, xml as xmppxml } from '@xmpp/client'
// import { client as xmppclient, xml as xmppxml } from '@/frontend/components/xmpp/xmpp.min.js'

// import Journal from "@/frontend/root/Journal";
import QSON from '@/common/QSON'
import Scroller from '@/frontend/root/Scroller'
import Context from "@/frontend/components/qecomps/Context";
import { SSRGlobal } from "@/frontend/components/qecomps/Context";
import { DeclarationsBefore, DeclarationsAfter, LangRestore, APILister } from "@/frontend/root/Declarations";
import Router from 'next/router';
// import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import { SessionProvider } from "next-auth/react";
import SerialGenerator from "@/frontend/components/qecomps/SerialGenerator";
import Nexus from "@/frontend/components/nexus/Nexus";
import { Loopez } from "@/common/dynamic";
import md5 from 'crypto-js/md5';
import Ico from "@/frontend/components/qecomps/Ico";
import HeaderBar from "@/frontend/components/menu/HeaderBar";
import Searcher from "@/frontend/components/menu/Searcher";
import VItem from "@/frontend/components/qecomps/VItem";
import Img from "@/frontend/components/qecomps/Img";
import UserAvatar from "@/frontend/components/qecomps/UserAvatar";
import { onLCP } from 'web-vitals';
const CalendarFA = dynamic(() => import("@/frontend/components/qecomps/CalendarFA").then(x => x.default), { ssr: false })
const CalendarEN = dynamic(() => import("@/frontend/components/qecomps/CalendarEN").then(x => x.default), { ssr: false })
const Calendar = dynamic(() => import("@/frontend/components/qecomps/Calendar").then(x => x.default), { ssr: false })


// import SerialGenerator from "@/frontend/components/qecomps/SerialGenerator";
// const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID || 'G-XXXXXXXXXX'; // Replace with your Measurement ID

const version = "0.06"

export default function App({ Component, pageProps }) {



  if (typeof window != "undefined") {
    QSON();
  }
  let props = {} as any
  try {
    if (typeof pageProps.data != "number") {
      let dataMD5 = md5(pageProps.data).toString();
      props = global.QSON.parse(pageProps.data)
      props.dataMD5 = dataMD5
    }
  } catch { }

  let z = SSRGlobal(props.pageid)

  z.root = "/" + props.langcode;
  z.styles = styles


  // if ((z["pagepath"] && z["pagepath"] != props.href) || (!global.pageid && !z.lang)) {
  //   z.lang = props.nlangs
  // }
  if (props.nlangs) {
    z.lang = props.nlangs
  }

  if (typeof window != "undefined") {

    // if (process.env.BUILDMODE)
    // global.window = global;

    DeclarationsBefore(props, z)
    Scroller();
    APILister(props)
    let ver = localStorage.getItem("version");
    if (ver != version) {
      localStorage.clear()
      localStorage.setItem("version", version)
      // window.location.reload()
    }

    let lng = localStorage.getItem("lang-" + props.langcode);
    if (lng && !z.lang.langfulldone) {
      z.lang = JSON.parse(lng)
      z.lang.langfulldone = true
      // reload()
    }
  }

  let sessionreloader: any = {};



  useEffect(() => {
    const handleRouteChange = (url: string) => {
      document.body.style.overflowY = "scroll";
    };
    Router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [Router.events]);


  useEffect(() => {
    if (!pageProps.data) {
      return
    }

    onLCP((metric) => {
      console.log('📏 LCP:', metric.value.toFixed(2), 'ms');
    });

    window.reloadsession = () => {
      global.noloading = true;
      window.winscrollers = {}
      window.onunloader?.()
      sessionreloader?.run?.();
    }
    global.pageProps = props

    // return
    DeclarationsAfter(props, z)


    LangRestore(props, z)
    APILister(props)


    if (global.devmode) {
      clearInterval(global.looper1)
      global.looper1 = setInterval(() => {
        APILister(props)
        Loopez()
      }, 3000);
    }


    // document.documentElement.setAttribute('data-theme', 'dark')
    // document.documentElement.classList.add("dark");   // enable dark

    // document.documentElement.setAttribute('data-theme', 'light')
    // document.documentElement.classList.add("light");   // enable dark
    // global.theme = "light"

  }, [])


  props["isPage"] = true

  if (!pageProps.data && process && process.env.BUILDMODE) {
    return null
  }

  if (typeof window != "undefined") {
    global.theme = document.body.getAttribute("data-theme")
  }

  return (
    <Context.Provider value={props.pageid}>
      <SessionProvider {...{
        session: props.session, refetchInterval: 0,
        sessionreloader: sessionreloader
      }}>
        {pageProps.data ? <Script src="/xmpp.min.js" strategy="lazyOnload" onLoad={() => { Nexus(z) }} defer /> : null}
        {pageProps.data ? <Calendar /> : null}
        {pageProps.data ? <CalendarEN /> : null}
        {pageProps.data ? <CalendarFA /> : null}
        {pageProps.data ? <Prompt /> : null}
        <Component {...props} />
        {pageProps.data ? <QELoader /> : null}
      </SessionProvider>
    </Context.Provider>
  )
}

